module.exports = __webpack_public_path__ + "img/meadowlake.0eed7724.png";